import { render, staticRenderFns } from "./loadingCircle.vue?vue&type=template&id=0b56e5ce&scoped=true&"
import script from "./loadingCircle.vue?vue&type=script&lang=js&"
export * from "./loadingCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56e5ce",
  null
  
)

export default component.exports